import { Grid } from "@mui/material";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { TextInput } from "components/FormControls/TextInput";
import { useMessage } from "hooks/intl";
import { useStyles } from "./styles";

export const labels: any = {
  "transaction.sku.qty": "SKU",
  "transaction.sku.grossValue": "SKU",
  "transaction.category.qty": "category",
  "transaction.category.grossValue": "category",
  "transaction.maker.qty": "brand",
  "transaction.maker.grossValue": "brand",
};
const PickLabel = (attribute: string) => {
  const { message } = useMessage();
  return message({ id: labels[attribute] });
};
export function AdditionalAttribute({
  attribute = "",
  fieldName,
}: {
  attribute: string;
  fieldName: string;
}) {
  const classes = useStyles();

  return labels.hasOwnProperty(attribute) ? (
    <Grid item xs={6}>
      <TextInput
        width="100%"
        className={classes.input}
        data-test-id="condition-additional-attribute"
        label={<RequiredFieldLabel text={PickLabel(attribute)} />}
        name={`${fieldName}.param`}
      />
    </Grid>
  ) : null;
}
